var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationSaved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/notification_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1182 12.0751L15.2849 10.6917C15.1099 10.3834 14.9516 9.80008 14.9516 9.45842V7.35008C14.9516 5.39175 13.8016 3.70008 12.1432 2.90841C11.7099 2.14175 10.9099 1.66675 9.99325 1.66675C9.08491 1.66675 8.26825 2.15841 7.83491 2.93341C6.20991 3.74175 5.08491 5.41675 5.08491 7.35008V9.45842C5.08491 9.80008 4.92658 10.3834 4.75158 10.6834L3.90991 12.0751C3.57658 12.6334 3.50158 13.2501 3.70991 13.8167C3.90991 14.3751 4.38491 14.8084 5.00158 15.0167C6.61825 15.5667 8.31825 15.8334 10.0182 15.8334C11.7182 15.8334 13.4182 15.5667 15.0349 15.0251C15.6182 14.8334 16.0682 14.3917 16.2849 13.8167C16.5016 13.2417 16.4432 12.6084 16.1182 12.0751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3568 16.6751C12.0068 17.6417 11.0818 18.3334 9.99844 18.3334C9.3401 18.3334 8.6901 18.0667 8.23177 17.5917C7.9651 17.3417 7.7651 17.0084 7.64844 16.6667C7.75677 16.6834 7.8651 16.6917 7.98177 16.7084C8.17344 16.7334 8.37344 16.7584 8.57344 16.7751C9.04844 16.8167 9.53177 16.8417 10.0151 16.8417C10.4901 16.8417 10.9651 16.8167 11.4318 16.7751C11.6068 16.7584 11.7818 16.7501 11.9484 16.7251C12.0818 16.7084 12.2151 16.6917 12.3568 16.6751Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSaved);
export default __webpack_public_path__ + "static/media/notification-saved.6cc3727c2df11868e82c0ec6367a5910.svg";
export { ForwardRef as ReactComponent };